<template>
  <el-form-item :label="form.name" :prop="form.model"
                :class="[form.options.required?'label-blue':'']"
                :rules="form.rules"
                :required="form.options.required"
                v-show="!form.options.hidden"
                 style="padding-left:10px;line-height:36px;"
  >
      <el-tooltip  v-model="tipShow" effect="light" content="桩号识别为千米桩号,例如:输入0.123将被转为K0+123" placement="top-start">
         <el-button type="info"  plain disabled style="width:118px;">{{value[form.model] | stakeFormFilter}}</el-button>
      </el-tooltip>
     <el-input-number v-model="value[form.model]"
              :placeholder="form.options.placeholder"
              :disabled="inputDisable"
              @input="onInput"
              @focus="onFocus"
              @blur="onBlur"
              :precision="3"
              :controls="false"
              :max="form.options.max"
              :min="form.options.min"
              @change="numChange"
              clearable
              style="width:116px;margin-left:-8px;"
              :type="form.options.dataType">
              </el-input-number>


  </el-form-item>
</template>

<script>
export default {
  name: 'InputStake',
 data () {
    return {
      key: '',
      formData: {},
      mainValue: '',
      tipShow:false
    }
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          name: '',
          prop: '',
          icon: '',
          className: '',
          options: {
            width: '100%',
            defaultValue: '',
            required: false,
            dataType: 'string',
            pattern: '',
            placeholder: '',
            max:0,
            min:0,
            customClass: '',
            disabled: false,
            remoteFunc: () => {},
            changeFunc: () => {}
          },
          key: '',
          model: 'value',
          rules: [{}]
        }
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => { return {} }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val, oldVal) {
        this.mainValue = val;
      }
    },
  },
  methods: {
    onInput (val) {
      let that = this
      // if(!isNaN(val)){
      //     that.value[that.form.model]=val.replace(/\.\d\d{3}$/,'')
      // }else{
      //   that.value[that.form.model] = ''
      //   return
      // }
      that.$emit('input', that.value, that.form.model)
      if (typeof that.form.options.changeFunc === 'function') { // 判断是否存在数据改变事件
        that.form.options.changeFunc(that.value[that.form.model], that, that.forms)
      }
    },
    setValue (val) {
      this.mainValue = val
    },
    numChange(val){
      let that = this
      if(!val){
        that.value[that.form.model]=0;
      }
    },
    onFocus (val) {
      let that = this
        that.tipShow = true
       val.currentTarget.select();
      if (typeof that.form.options.onFocus === 'function') { // 判断是否存在数据改变事件
        that.form.options.onFocus()
      }
    },
      onBlur(){
          this.tipShow=false
      }
  },
  created () {
    let that = this
    that.key = that.form.key
    if (that.form.hasOwnProperty('options')) {
      that.value[that.form.model] = that.value[that.form.model] || this.form['options']['defaultValue'] || ''
    }
  },
  mounted () {
    let that = this
    that.$emit('init', that.key, that)
  },
  computed: {
    inputDisable () {
      return this.disabled || this.form.options.disabled
    }
  }
}
</script>

<style scoped>

</style>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/InputStake.vue"
}
</vue-filename-injector>
